import { useState } from "react";
import "./App.css";
import { baseUrl } from "./Url";
import Swal from "sweetalert2";

function App() {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    contactNumber: "",
    date: "",
    time: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submissionData = new FormData();
    submissionData.append("name", formData.name);
    submissionData.append("email", formData.email);
    submissionData.append("company_name", formData.companyName || "");
    submissionData.append("contact_number", formData.contactNumber || "");
    submissionData.append("select_time", formData.time || "");
    submissionData.append("select_date", formData.date || "");
    submissionData.append("special_massage", formData.message || "");

    try {
      const response = await fetch(`${baseUrl}/api/submit`, {
        method: "POST",
        body: submissionData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data);
      }

      await Swal.fire({
        icon: "success",
        title: "Appointment Confirmed",
        text: "Your appointment has been successfully confirmed!",
      });
      
      setFormData({
        name: "",
        companyName: "",
        email: "",
        contactNumber: "",
        date: "",
        time: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  return (
    <div>
      <div className="header">
        <h2>Redefining Diamonds, Revolutionizing Jewelry, Empowering Success.</h2>
        <p>Secure Your Spot Now and Experience Excellence and Discover How We Can Elevate Your Collection.</p>
      </div>

      <div className="jck_section">
        <div className="jck_p">
          <p>
            Be Among the First to Explore Skylab’s Finest Diamonds, Groundbreaking <br />
            Designs, and Industry-Leading Craftsmanship at JCK Las Vegas.
          </p>
        </div>

        <div className="jck_part">
          {/* section_1 */}
          <div className="jck_img">
            <div className="boothNo">
              <img src="/Booth No.png" width={500} height={200} alt="Booth Number" />
            </div>
            <div>
              <img src="/Booth.png" width={600} height={400} alt="Booth" />
            </div>
          </div>

          <div className="line"></div>

          {/* section_2 */}
          <div className="jck-form">
            <h3>Book Your Exclusive Appointment</h3>
            <div className="bottom_line"></div>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <label>
                  Your Name<span>*</span>:
                </label>
                <input type="text" name="name" placeholder="Your Name*" required value={formData.name} onChange={handleChange} />

                <label className="label">
                  Company Name<span>*</span>:
                </label>
                <input type="text" name="companyName" placeholder="Company Name*" required value={formData.companyName} onChange={handleChange} />
              </div>

              <div className="form-row">
                <label>
                  Email<span>*</span>:
                </label>
                <input type="email" name="email" placeholder="Email*" required value={formData.email} onChange={handleChange} />

                <label className="label">
                  Contact Number<span>*</span>:
                </label>
                <input type="tel" name="contactNumber" placeholder="Contact Number*" required value={formData.contactNumber} onChange={handleChange} />
              </div>

              <div className="form-row">
                <label>
                  Select Date<span>*</span>:
                </label>
                <select name="date" required value={formData.date} onChange={handleChange}>
                  <option value="">Select Date</option>
                  <option value="2026-05-29">May 29, 2026 (Friday)</option>
                  <option value="2026-05-30">May 30, 2026 (Saturday)</option>
                  <option value="2026-05-31">May 31, 2026 (Sunday)</option>
                  <option value="2026-06-01">June 1, 2026 (Monday)</option>

                  
                </select>

                <label className="label">
                  Select Time (PDT)<span>*</span>:
                </label>
                <select name="time" required value={formData.time} onChange={handleChange}>
                  <option value="">Select Time (PDT)</option>
                  <option value="8:30 AM - 9:30 AM">8:30 AM - 9:30 AM</option>
                  <option value="9:30 AM - 10:30 AM">9:30 AM - 10:30 AM</option>
                  <option value="10:30 AM - 11:30 AM">10:30 AM - 11:30 AM</option>
                  <option value="11:30 AM - 12:30 PM">11:30 AM - 12:30 PM</option>
                  <option value="12:30 PM - 1:30 PM">12:30 PM - 1:30 PM</option>
                  <option value="1:30 PM - 2:30 PM">1:30 PM - 2:30 PM</option>
                  <option value="2:30 PM - 3:30 PM">2:30 PM - 3:30 PM</option>
                  <option value="3:30 PM - 4:30 PM">3:30 PM - 4:30 PM</option>
                  <option value="4:30 PM - 5:30 PM">4:30 PM - 5:30 PM</option>
                  <option value="5:30 PM - 6:00 PM">5:30 PM - 6:00 PM</option>
                </select>
              </div>

              <label className="message">Your Special Message:</label>
              <textarea name="message" placeholder="Your Special Message" value={formData.message} onChange={handleChange}></textarea>

              <p>Your Next Best-Selling Collection Starts Here</p>
              <button type="submit" className="submit-btn">
                Confirm Appointment
              </button>
            </form>

            <p className="welcome-text">Book Your Appointment Today!</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
